import { render, staticRenderFns } from "./CreditAssessmentLogSummaryAdapter.vue?vue&type=template&id=391bc164&scoped=true&"
import script from "./CreditAssessmentLogSummaryAdapter.vue?vue&type=script&lang=js&"
export * from "./CreditAssessmentLogSummaryAdapter.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=391bc164&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391bc164",
  null
  
)

export default component.exports